export default {
  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies / Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants / Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear / Underpants",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",

  "cat.shoes.desc": "Sneakers & everyday footwear",
  "cat.hoodies.desc": "Cozy pullovers & sweatshirts",
  "cat.tshirts.desc": "Casual tees for daily wear",
  "cat.jackets.desc": "Layers for cooler days",
  "cat.pants.desc": "Joggers, pants & shorts",
  "cat.headwear.desc": "Caps, beanies & more",
  "cat.sets.desc": "Matching two-piece outfits",
  "cat.underwear.desc": "Comfort-first everyday basics",
  "cat.jersey.desc": "Game-day team jerseys",
  "cat.accessories.desc": "Small gear & extras",
  "cat.bags.desc": "Totes, packs & carry",
  "cat.belts.desc": "Straps & waistwear",
  "cat.perfumes.desc": "Fresh signature scents",
  "cat.other.desc": "Everything else fans love",

  "home.heroBadge": "Independent Fan Merch Resource",
  "home.heroTitle": "The US Fans Spreadsheet — Every Fan Merch Category in One Place",
  "home.heroSubtitle": "Browse shoes, jerseys, hoodies and more through a clean, organized resource that helps you find your favorite fan gear faster.",
  "home.heroCta1": "usfans spreadsheet",
  "home.heroCta2": "buy it now",
  "home.heroTrust": "Quick category links • Curated fan gear • Regularly updated",

  "home.dropdownTitle": "Browse Fan Merch Categories",
  "home.dropdownSubtitle": "Pick a category from the menu below to jump straight to that collection on our main store.",

  "home.categoriesTitle": "Explore Every Category",
  "home.categoriesSubtitle": "Tap any category to open its dedicated collection page on the main store.",

  "home.aboutTitle": "What Is the US Fans Spreadsheet?",
  "home.aboutP1": "The US Fans Spreadsheet is an organized, easy-to-navigate resource that collects fan merchandise into clearly labeled categories. Instead of digging through scattered pages, you can jump straight to the gear you want — from shoes and jerseys to hoodies, jackets, bags and accessories.",
  "home.aboutP2": "Every category links directly to a curated collection on our main store, so you spend less time searching and more time finding pieces that match your style. Whether you are hunting for a fresh pair of sneakers or a full matching set, everything is one click away.",
  "home.aboutB1": "Organized fan merchandise in one clean place",
  "home.aboutB2": "Direct links to every major category",
  "home.aboutB3": "Beginner-friendly guidance",
  "home.aboutB4": "Regularly updated collections",

  "home.guideTitle": "Featured Guide",
  "home.guideSubtitle": "Dive deeper into how this resource works and how to choose the right fan gear.",
  "home.guideCategory": "Buying Guide",
  "home.guideCardTitle": "What Is the US Fans Spreadsheet? A Complete Guide",
  "home.guideCardDesc": "Learn how this resource works, which categories are available, and how to pick the right fan merchandise.",
  "home.guideRead": "Read the guide",
  "home.guideTime": "6 min read",
};